import React from 'react'

const Menu = () => {
  return (
    <div style={{ backgroundColor: 'lime', padding: '1rem' }}>
      MENU ATIVO EM REACT ✅
    </div>
  )
}

export default Menu
